import React from "react";
import { useFormSection, FormSectionProps } from "../../hooks/useFormSection";

const OtherConditionsSectionV2: React.FC<FormSectionProps> = (props) => {
  const { Field } = useFormSection(props);

  return (
    <div className="bg-brand-stone-50 p-6 rounded-lg border border-brand-stone-200">
      <Field
        path="healthAndMedicalConditions.otherConditions"
        label="Do you have any other medical condition, concerns or issues that has not been addressed above? Please list."
        type="textarea"
        rows={4}
      />
    </div>
  );
};

export default OtherConditionsSectionV2;